export default __webpack_public_path__ + "alberta-fab-resend.0c40e501c902e29b80b8.svg";